import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GetAllJobList } from '../../../Redux/action/JobDetailsAction';
import { IoSearch } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaEllipsisH, FaEye } from 'react-icons/fa';
import Pagination from '../../Common/Pagination/Pagination';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const JobPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pageNumber, setPageNumber] = useState(0);
    const [size, setSize] = useState(8);
    const [search, setSearch] = useState('');

    const location = useLocation();
    const currentTab = new URLSearchParams(location.search).get('active')?.toUpperCase()
    // console.log("query",currentTab);

    const [activeTab, setActiveTab] = useState(currentTab ?? 'ALL')

    useEffect(() => {
        // console.log("HII",activeTab)
        dispatch(GetAllJobList({ pageNumber, size, search, activeTab }))
    }, [pageNumber, search, activeTab])
    const loader = useSelector((state) => state?.JobPageDashboard?.loading)
    const JobDetails = useSelector((state) => state?.JobPageDashboard?.result?.jobs);
    const totalPages = useSelector((state) => state?.JobPageDashboard?.result?.totalPages);

    const [showOptionsForId, setShowOptionsForId] = useState(null); // State to track which row's options are shown
    const optionsRef = useRef(null);

    const toggleOptions = (id) => {
        setShowOptionsForId(showOptionsForId === id ? null : id);
    };

    const handlePageChange = (page) => {
        // You can also fetch data for the new page here or update your component state according
        setPageNumber(page);
    };

    useEffect(() => {
        // Function to handle clicks outside the options menu
        const handleClickOutside = (event) => {
            if (optionsRef.current && !optionsRef.current.contains(event.target)) {
                setShowOptionsForId(null); // Close options menu if clicked outside
            }
        };

        // Add event listener to handle clicks outside the menu
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleTabChange = (tab) => {
        console.log("setActive..", tab);
        setActiveTab(tab)
    }

    // console.log("jobb",getJobDetails);
    return (
        <div style={{ backgroundColor: '#f6f9ff', height: '100vh', paddingTop: '16px' }}>

            <div className=' mb-4 d-flex justify-content-between align-items-center' style={{ fontSize: '14px', width: '95%', backgroundColor: 'white' }}>
                <ul className="nav nav-pills justify-content-between">
                    <li className="nav-item">
                        <Link to='/admin/job?active=all'>
                            <button className={`nav-link ${activeTab === "ALL" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange('ALL')}>All Jobs</button>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/admin/job?active=posted'>
                            <button className={`nav-link ${activeTab === "POSTED" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("POSTED")}>Posted Jobs</button>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/admin/job?active=onhold'>
                            <button className={`nav-link  ${activeTab === "ONHOLD" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("ONHOLD")}>Onhold Jobs</button>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/admin/job?active=expired'>
                            <button className={`nav-link  ${activeTab === "EXPIRED" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("EXPIRED")}>Expired Jobs</button>
                        </Link>
                    </li>
                </ul>
            </div>

            <div className="common_wrapper " style={{ width: '95%', backgroundColor: 'white' }}>
                <div className="card-header common_table_header" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>{activeTab ? `${activeTab?.split('')[0] + activeTab.slice(1).toLowerCase()} Jobs` : 'All Jobs '}</div>
                    <div>
                        <div style={{ width: '13rem', height: '100%', backgroundColor: 'white', borderRadius: '0.275rem', display: 'flex', border: '1px solid #eee6e4' }}>
                            <div style={{ width: '2rem', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IoSearch style={{ color: '#286A94', fontSize: '1.25rem' }} />
                            </div>
                            <input
                                className="small-placeholder"
                                style={{ width: '100%', height: '66.67%', margin: 'auto 0', paddingLeft: '0.5rem', outline: 'none', border: 'none' }}
                                placeholder="Search by company"
                                type="text"
                                value={search}
                                onChange={(e) => [setSearch(e.target.value), setPageNumber(0)]}
                            />
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive" style={{}}>
                        <table className="table-data" style={{ width: "100%", fontSize: "14px", overflowX: 'auto', minWidth: '63rem' }}>
                            <thead>
                                <tr style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', textAlign: 'start', wordBreak: 'break-word', fontFamily: 'Poppins, sans-serif' }}>
                                    {/* <th className="fw_600" scope="col">Job ID</th> */}
                                    <th className="fw_600" scope="col">Vendor ID</th>
                                    <th className="fw_600" style={{ gridColumn: 'span 2' }} scope="col">Company</th>
                                    <th className="fw_600" style={{ gridColumn: 'span 2' }} scope="col">Owner Name</th>
                                    {/* <th className="fw_600" scope="col">Validity</th> */}
                                    <th className="fw_600" scope="col">Job Posted</th>
                                    <th className="fw_600" scope="col">Active Job</th>
                                    {/* <th className="fw_600" scope="col">Experience</th> */}
                                    <th className="fw_600" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loader ?
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <div style={{ padding: '20px' }}>
                                                    <Spinner style={{ color: '#286a94' }} />
                                                </div>
                                            </td>
                                        </tr> : Array?.isArray(JobDetails) && JobDetails?.length > 0 ? (
                                            JobDetails?.map((item, i) => {
                                                console.log('ITEM LOC--', item?.jobLocation?.split(',')?.slice(0, 3)?.join(' '))
                                                return (
                                                    <>
                                                        <tr key={i} style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', textAlign: 'start', wordBreak: 'break-word', fontFamily: 'Poppins, sans-serif' }}>
                                                            {/* <td>{item?.jobId}</td> */}
                                                            <td>{item?.vendorEmpId}</td>
                                                            <td style={{ gridColumn: 'span 2' }}>{`${item?.companyName}`}</td>
                                                            <td style={{ gridColumn: 'span 2' }}> {item?.vendorFullName || 'N/A'}</td>
                                                            {/* <td>{item?.validity || 'N/A'}</td> */}
                                                            <td>{item?.postedJob}</td>
                                                            {/* <td style={{ gridColumn: 'span 2' }}>
                                                                <span className={`${item?.jobLocation && item.jobLocation !== 'Remote' ? 'me-2 arc_tooltip' : ''}`} data-tooltip={item?.jobLocation && item.jobLocation !== 'Remote' ? item.jobLocation : undefined}>
                                                                    {item?.jobLocation === '' ? 'Remote' : `${item?.jobLocation.split(',').slice(0, 2).join(',')}...`}
                                                                </span>
                                                            </td> */}
                                                            <td>{item?.activeJob}</td>
                                                            <td ><div onClick={() => navigate(location.pathname.includes('admin')
                                                                ? `/admin/job/vendor_jobs?vendorId=${item?.vendorId}`
                                                                : '/schedule-interview'
                                                            )} style={{ paddingLeft: 20 }}>
                                                                <FaEye style={{ cursor: "pointer", fontSize: "1.125rem", margin: "0 auto" }} />
                                                            </div> </td>
                                                            {/* <td>
                                        {item?.minimumExperience && item?.maximumExperience 
                                        ? `${item.minimumExperience} - ${item.maximumExperience}` 
                                        : 'N/A'}
                                        </td> */}
                                                            {/* <td>
                                                                <div style={{ position: "relative" }}>
                                                                    <FaEllipsisH
                                                                        onClick={() => toggleOptions(item?.jobId)}
                                                                        style={{ cursor: "pointer", margin: "0 1rem" }}
                                                                    />
                                                                    {showOptionsForId === item?.jobId && (
                                                                        <div
                                                                            style={{
                                                                                position: "absolute",
                                                                                backgroundColor: "white",
                                                                                border: "1px solid #e5e7eb",
                                                                                borderRadius: "0.125rem",
                                                                                marginTop: "0.25rem",
                                                                                width: "6rem",
                                                                                right: 0,
                                                                                zIndex: 10,
                                                                            }}
                                                                            ref={optionsRef}
                                                                        >
                                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                                    <div
                                                                                        style={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            margin: "0 auto",
                                                                                            padding: "0.25rem 0.5rem",
                                                                                            width: "100%",
                                                                                            borderBottom: "1px solid #e5e7eb",
                                                                                            cursor: "pointer",
                                                                                            ':hover': { backgroundColor: "#f1f5f9" }
                                                                                        }}
                                                                                        onClick={() => navigate(`/admin/job/viewJob?jobId=${item?.jobId}`)}
                                                                                    >
                                                                                        <p style={{ margin: "0 auto" }}>View</p>
                                                                                        <FaEye style={{ cursor: "pointer", fontSize: "1.125rem", margin: "0 auto" }} />
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td> */}
                                                        </tr>
                                                    </>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center fw-600">
                                                    <h5 style={{ fontSize: '14px', paddingTop: '10px' }} >No Data Found</h5>
                                                </td>
                                            </tr>
                                        )
                                }


                            </tbody>
                        </table>
                    </div>
                </div>
                <div>
                    {
                        JobDetails?.length >= 1 ? (
                            <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
                        ) : (
                            ""
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default JobPage;
